import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import DeleteComponent from "../common/DeleteComponent";
import EditComponent from "../common/EditComponent";
import {Arguments} from "../common/Arguments";
import {sideMenuContext} from "../../../router/IndexRouter";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import {DateRangePicker} from "../common/SelectDateRange";

export default function OtherActivities(props) {
    const currentUrl = window.location.href;
    const {dataSource, setDataSource, setCopyDataSource, copyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/society/api!otherActivity.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '活动名称',
            dataIndex: 'activityName',
            width: 220
        },
        {
            title: '活动主题',
            responsive: ['lg'],
            dataIndex: 'activitySubject',
            width: 220
        },
        {
            title: "活动时间",
            dataIndex: 'activityDate',
            width: 120
        },
        {
            title: "活动规模",
            responsive: ['lg'],
            dataIndex: 'activityScope',
            width: 110
        },
        {
            title: "活动地址",
            dataIndex: 'activityAddress',
            width: 200
        },
        {
            title: "发言嘉宾",
            dataIndex: 'activityExpert',
            width: 120
        },
        {
            title: "备注",
            responsive: ['lg'],
            dataIndex: 'activityMemo',
            width: 110
        },
        {
            title: "审核状态",
            dataIndex: 'checkStatus',
            width: 100
        },
        {
            title: "操作",
            width: 150,
            render: (item) => (
                <>
                    <EditComponent item={item} url={currentUrl}/>
                    <DeleteComponent
                        item={item}
                        postApi={[Arguments.host + "/society_organization/society/api!addOtherActivity.do"]}
                        getApi={getApi}
                    />
                </>
            )
        }
    ];
    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))
    return (
        <>
            <Button type="primary" onClick={() => props.history.push("/society/other-activity/add")}
                    style={{marginBottom: 10}}>新增</Button>
            <DateRangePicker dataSource={dataSource} setDataSource={setDataSource} copyDataSource={copyDataSource}/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}


